import { render } from "./flats-section.vue?vue&type=template&id=4767ca04"
import script from "./flats-section.vue?vue&type=script&lang=js"
export * from "./flats-section.vue?vue&type=script&lang=js"

import "./flats-section.vue?vue&type=style&index=0&id=4767ca04&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__